import React from "react";

export const ANALYTICS_AREA_FILL_GRADIENT = {
  topOffset: "5%",
  bottomOffset: "95%",
  topOpacity: 0.35,
  bottomOpacity: 0.02,
} as const;

export function analyticsAreaFillGradientId(
  seriesKey: string,
  chartInstanceId?: string,
): string {
  const safeKey = seriesKey.replace(/[^a-zA-Z0-9-_]/g, "-");
  return chartInstanceId
    ? `analytics-area-fill-${chartInstanceId}-${safeKey}`
    : `analytics-area-fill-${safeKey}`;
}

export function analyticsAreaFillUrl(
  seriesKey: string,
  chartInstanceId?: string,
): string {
  return `url(#${analyticsAreaFillGradientId(seriesKey, chartInstanceId)})`;
}

type AnalyticsAreaFillDefsProps = {
  seriesKeys: readonly string[];
  chartInstanceId?: string;
  /** Literal colors per key; omit to use `var(--color-{key})` from ChartContainer */
  colors?: Record<string, string>;
};

export function AnalyticsAreaFillDefs({
  seriesKeys,
  chartInstanceId,
  colors,
}: AnalyticsAreaFillDefsProps) {
  const { topOffset, bottomOffset, topOpacity, bottomOpacity } =
    ANALYTICS_AREA_FILL_GRADIENT;

  return (
    <>
      {seriesKeys.map((key) => {
        const id = analyticsAreaFillGradientId(key, chartInstanceId);
        const stopColor = colors?.[key] ?? `var(--color-${key})`;

        return (
          <linearGradient key={id} id={id} x1="0" y1="0" x2="0" y2="1">
            <stop
              offset={topOffset}
              stopColor={stopColor}
              stopOpacity={topOpacity}
            />
            <stop
              offset={bottomOffset}
              stopColor={stopColor}
              stopOpacity={bottomOpacity}
            />
          </linearGradient>
        );
      })}
    </>
  );
}

export function useAnalyticsChartInstanceId(): string {
  return React.useId().replace(/:/g, "");
}
